import { Translations } from './types';

export const de: Translations = {
  nav: {
    about: 'Über Uns',
    kostprobe: 'Kostprobe',
    barbershop: 'Barbershop?',
    book: 'Kontakt',
  },
  about: {
    label: 'Über Uns',
    text: 'Vereint durch die Liebe zur Barbershop-Musik gründeten wir in 2023 unser Vocal-Ensemble Veto. Als deutsch-amerikanisches Vierergespann bringen wir Popsongs aus verschiedenen Jahrzehnten auf die Bühne – vierstimmig und natürlich a cappella. Und das mit Erfolg: Seit 2025 sind wir amtierende Europameister im gemischten Barbershop-Gesang. Von Herzschmerz-Ballade über Swing- und Jazz-Standards bis zu Christmas Carols – wir bringen Leben in die Bude und Gefühle ins Herz.',
    members: [
      { name: 'Sandra Rembecki', role: 'Tenor' },
      { name: 'Robbie Weber', role: 'Lead' },
      { name: 'Mira Taferner', role: 'Bariton' },
      { name: 'Andrew Rembecki', role: 'Bass' },
    ],
  },
  kostprobe: {
    label: 'Kostprobe',
    caption1: 'Quartett Finale BinG! Barbershop Musikfestival 2026',
    caption2: 'Musik in den Bergen im BR',
    caption3: 'Quartett Finale Europäische Barbershop Convention 2025',
    caption4: 'Gastauftritt bei Wir in Bayern im BR',
    caption5: 'Quartett Halbfinale BinG! Barbershop Musikfestival 2026',
  },
  barbershop: {
    label: 'Barbershop?',
    title: 'Was ist Barbershop?',
    p1: 'Barbershop-Musik klingt ein bisschen so, als würden vier Herren mit geschniegeltem Schnurrbart im Friseursalon stehen und über Rasiercreme singen – und ganz falsch ist das nicht. Früher trafen sich Männer tatsächlich oft in Barbershops, also Friseurläden, und sangen dort gemeinsam.',
    p2: 'Heute ist Barbershop eine moderne, lebendige A-cappella-Musikrichtung, die Menschen aller Altersgruppen begeistert – oft gemischt, kreativ und mit ordentlich Bühnenenergie. Vierstimmiger Gesang steht zwar im Mittelpunkt, aber der Stil lebt vor allem von Spaß, Ausdruck und diesen Gänsehaut-Harmonien, bei denen plötzlich alles perfekt zusammenklingt. Gesungen wird dabei nicht nur klassisch oder nostalgisch: Viele Gruppen bringen Pop, Musical oder moderne Arrangements auf die Bühne – mal emotional, mal urkomisch und oft beides gleichzeitig. Wer einmal ein gutes Barbershop-Quartett live gehört hat, weiß: Da braucht es keine Instrumente mehr, wenn die Stimmen anfangen zu ringen.',
    p3: 'Im deutschsprachigen Raum verbindet der Verband BinG! Sängerinnen und Sänger aus Deutschland und darüber hinaus. Der Verein organisiert Festivals, Wettbewerbe und Workshops und zeigt, wie modern und vielseitig Barbershop heute ist.',
  },
  book: {
    label: 'Buche Uns!',
    text: 'Egal ob Hochzeit, Geburtstag, Firmen- und Gartenparty oder Wohnzimmerkonzert – wir bereichern dein Event als kleine musikalische Einlage oder auch gerne mit einem längeren Programm.',
    contact: 'Kontakt',
    contactName: 'Sandra Rembecki',
    contactSuffix: 'Ansprechpartnerin',
    emailSubject: 'Quartett Anfrage',
  },
  footer: {
    email: 'vetoquartet@gmail.com',
  },
};

export const en: Translations = {
  nav: {
    about: 'About',
    kostprobe: 'Sample Our Sound',
    barbershop: 'Barbershop?',
    book: 'Contact',
  },
  about: {
    label: 'About Us',
    text: `Four voices, one shared obsession: barbershop music. That's how Veto was born in 2023. We're a German-American quartet putting our own four-part, fully a cappella spin on pop songs from every decade you can think of — no instruments, no backing tracks, just us. And apparently we're pretty good at it: reigning European Champions in mixed barbershop singing since 2025. Heart break ballads, swing, jazz standards, Christmas carols — whatever we sing, we bring the room to life and go straight for the heartstrings.`,
    members: [
      { name: 'Sandra Rembecki', role: 'Tenor' },
      { name: 'Robbie Weber', role: 'Lead' },
      { name: 'Mira Taferner', role: 'Baritone' },
      { name: 'Andrew Rembecki', role: 'Bass' },
    ],
  },
  kostprobe: {
    label: 'Preview',
    caption1: 'Quartet Final BinG! Barbershop Music Festival 2026',
    caption2: 'Musik in den Bergen on BR (Bavarian Public Broadcaster)',
    caption3: 'Quartet Final European Barbershop Convention 2025',
    caption4: 'Featured on Wir in Bayern on BR (Bavarian Public Broadcaster)',
    caption5: 'Quartet Semi-final BinG! Barbershop Music Festival 2026',
  },
  barbershop: {
    label: 'Barbershop?',
    title: 'What is Barbershop?',
    p1: "It's exactly what you're picturing: four guys with wildly groomed mustaches, standing in a barbershop, harmonizing about shaving cream. And okay — that's not actually far off. Men really did used to hang out in barbershops and sing together, back in the day.",
    p2: `Fast forward to now, and barbershop has grown into a modern, seriously alive style of a cappella that hooks people of every age — often mixed voices, always creative, and with way more stage energy than you'd expect from something with shop in the name. Sure, it's built on four-part harmony, but what makes it special is the fun, the expression, and those goosebump harmonies where everything suddenly locks — like the universe briefly agrees with itself.`,
    p3: `And don't expect only old-timey nostalgia: plenty of groups throw pop, musical theatre, and modern arrangements into the mix — sometimes gut-wrenching, sometimes ridiculous, often both in the same song. Once you've heard a good barbershop quartet live, you get it: when the voices start to ring, instruments start to feel unnecessary.`,
    p4: "In the German-speaking world, the association BinG! brings singers together from Germany and beyond — running festivals, competitions, and workshops, and proving barbershop is anything but a museum piece.",
  },
  book: {
    label: 'Book Us!',
    text: "Getting hitched? Birthday? Corporate event? Garden Party — whatever the occasion, we'll show up and make it better. Want a quick musical cameo between dinner and desset? Great. Want a full-length set? Even better.",
    contact: 'Contact',
    contactName: 'Sandra Rembecki',
    contactSuffix: 'Contact person',
    emailSubject: 'Quartet Request',
  },
  footer: {
    email: 'vetoquartet@gmail.com',
  },
};
